import React,{ useState} from 'react';
import { useDispatch, connect} from 'react-redux';
import { Divider, Toggle, Loader } from 'rsuite';
import * as actionsAuth  from '../../../../app/actions/auth/auth';
import * as actionsUser  from '../../../../app/actions/user';
import * as actionsPayment  from '../../../../app/actions/payment';
import {BackIcon, Out1, Out2} from '../svg/iconsSvg';

export const ProfileMain = ({onBack, onForward, logout, style}) => {

    const dispatch = useDispatch();

    const [loading, setLoading] = useState(false);

    const goBack = () => onBack();

    const exitProfile = () => {
        logout();
       // clearUserDetails();
        onForward(1);
    }

    const goToUserData = () => {
        onForward(4)
    }

    const goToAddresses = async () =>  {
        setLoading(true);
        await dispatch(actionsUser.getUserAddresses());
        onForward(7);
    }

    const goToPaymentCards = async () => {
        setLoading(true);
        await dispatch(actionsPayment.getPaymentCards());
        onForward(8)
    }

    return (
        <div className="steps_container" style={style}>
            <div className="head">
                <div className="head-icon" style={{paddingLeft: '2rem'}} onClick={goBack}><BackIcon size={32}/></div>
                <h6 className="title" style={{marginRight: '48px'}}>Профил</h6>
            </div>
            <div className="profile" style={{marginBottom: '40px'}}>
                <Divider />
                <div className="with-toggle" onClick={exitProfile} style={{cursor: 'pointer'}}>
                    <h6 >Изход от профила</h6>
                    <div style={{display: 'flex', opacity: '.7'}}>
                        <Out1 /><Out2 />
                    </div>
                </div>
                <Divider />
                <h6 onClick={goToUserData}>Моите данни</h6>
                <Divider />
                <h6 onClick={goToAddresses}>Адреси</h6>
                <Divider />
                <h6 onClick={goToPaymentCards}>Карти за плащане</h6>
                <Divider />
                <div className="with-toggle">
                    <h6 >Маркетингови съобщения по меил</h6>
                    <Toggle arial-label="Switch" className="align-center" size="lg"  
                            defaultChecked={true}
                            onChange={(data) => {}} />
                </div>
                <Divider />
                <div className="with-toggle">
                    <h6 >Маркетингови съобщения по телефон</h6>
                    <Toggle arial-label="Switch" className="align-center" size="lg"  
                            defaultChecked={false}
                            onChange={(data) => {}} />
                </div>
                <Divider />
            </div>
 

            {loading ? <Loader backdrop center size="lg" speed="slow" /> : null }
        </div>
    )
}

export default connect(null, {...actionsAuth })(ProfileMain);